import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames/bind';

import IconSpinner from 'media/spinner.svg';

import styles from './Loader.module.scss';
const cx = classNames.bind(styles);

const Loader = ({ className }) => (
  <div className={cx('loader', className)}>
    <div className={cx('icon')}>
      <img src={IconSpinner} alt="Loading..." />
    </div>
  </div>
);

Loader.propTypes = {
  className: string,
};

Loader.defaultProps = {
  className: null,
};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js